import {} from "viem";
import { arbitrum, arbitrumGoerli, arbitrumSepolia } from "viem/chains";
export const minPriorityFeePerBidDefaults = new Map([
    [arbitrum.id, 10000000n],
    [arbitrumGoerli.id, 10000000n],
    [arbitrumSepolia.id, 10000000n],
]);
export const getDefaultUserOperationFeeOptions = (chain) => {
    return {
        maxPriorityFeePerGas: {
            min: minPriorityFeePerBidDefaults.get(chain.id) ?? 100000000n,
            multiplier: 1.33,
        },
    };
};
//# sourceMappingURL=defaults.js.map